import React, { Component } from 'react';


import Core from './../../Core/Core'
import ErrorManager from '../../Core/ErrorManager';

class Edits extends Component
{
    render()
    {
        let edits = this.props.edits == null ? [] :
        this.props.edits.map((e) => {
            let date = e.date != null ? (new Date(e.date*1000)) : null;
            if(date != null)
                date = date.getDate().toString().padStart(2, "0")+"/"+(date.getMonth()+1).toString().padStart(2, "0")+"/"+date.getFullYear()+" "+date.getHours().toString().padStart(2, "0")+":"+date.getMinutes().toString().padStart(2, "0");
            return (
                <tr key={ e.id }>
                    <td>{ e.email }</td>
                    <td>{ date }</td>
                    <td>{ e.reason }</td>
                </tr>
            );
        });
        return (
            <table className="table">
                <thead>
                    <tr>
                        <th>Utilisateur</th>
                        <th>Date</th>
                        <th>Raison</th>
                    </tr>
                </thead>
                <tbody>
                    { edits }
                </tbody>
            </table>
        );
    }
}

export default Edits;


// WEBPACK FOOTER //
// ./src/Components/Edit/Edits.js